import React from 'react';
import artwork1 from '../images/works/artwork1.jpg';
import artwork2 from '../images/works/artwork2.jpg';
import artwork3 from '../images/works/artwork3.jpg';
import artwork4 from '../images/works/artwork4.jpg';
import artwork5 from '../images/works/artwork5.jpg';
import artwork6 from '../images/works/artwork6.jpg';
import artwork7 from '../images/works/artwork7.jpg';
import artwork8 from '../images/works/artwork8.jpg';
import artwork9 from '../images/works/artwork9.jpg';
import artwork10 from '../images/works/artwork10.jpg';
import artwork11 from '../images/works/artwork11.jpg';
import artwork12 from '../images/works/artwork12.jpg';

import './Collage.css';

const Collage = () => {
    const artworks = [
        artwork1, artwork2, artwork3, artwork4,
        artwork5, artwork6, artwork7, artwork8,
        artwork9, artwork10, artwork11, artwork12
    ];

    return (
        <div className="collage-grid">
            {artworks.map((artwork, index) => (
                <div key={index} className="collage-item">
                    <img
                        src={artwork}
                        alt={`Artwork ${index + 1}`}
                        loading="lazy"
                    />
                </div>
            ))}
        </div>
    );
};

export default Collage;